<template>
  <div
    class="Card"
    :style="{ '--shadow-type': shadows[type] }"
    :data-active="active"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CareerCard',
  props: ['type', 'active'],
  data() {
    return {
      shadows: {
        big: '0px 3px 6px #00000029',
        small: '0px 5px 30px #00000029',
      },
    };
  },
};
</script>

<style scoped>
.Card {
  box-shadow: var(--shadow-type);
  min-width: var(--card-width);
  --career-card-max-width: auto;
  --card-width: 146px;
  height: 64px;
  padding: 1em;
  display: grid;
  grid-template-columns: 1fr auto;
  border-radius: 8px;
  max-width: var(--career-card-max-width);
  color: #2b4047;
  display: flex;
}
.title {
  grid-column: 1;
}
@media (min-width: 768px) {
  .Card {
    --card-width: 270px;
    --career-card-max-width: 400px;
  }
}
.Card[data-active='true'] {
  background: #12a291;
  color: white !important;
}
</style>
